import { render, staticRenderFns } from "./cmpViewer3D.vue?vue&type=template&id=ab520b18&"
import script from "./cmpViewer3D.vue?vue&type=script&lang=ts&"
export * from "./cmpViewer3D.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports